export default __webpack_public_path__ + "static/media/card1.32891cd7.png";